export default function (change) {
  switch (change) {
    case "Comments":
      return "Comentario";
    case "Door":
      return "Puerta";
    case "DoorAccess":
      return "Accesos";
    case "Entry":
      return "Entradas";
    case "Sensor":
      return "Sensor";
    case "UserIdentities":
      return "Identidades del usuario";
    case "UsersCompanies":
        return "Usuario";
    case "Zone":
        return "ZonA";
    default:
      return change;
  }
}
